import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// services
import { ParticipantSettingService } from 'src/app/services/participant-setting.service';

// models
import { Event } from 'src/app/models/event';

import { BasePage } from '../base';
import { TrnsPipe } from 'src/app/pipes/string/trns';
import { TranslatePipe } from '@ngx-translate/core';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.page.html',
    styleUrls: ['./unsubscribe.page.scss'],
})
export class UnsubscribePage extends BasePage implements OnInit, OnDestroy {

    /**
     * loading state
     *
     * @type {boolean}
     */
    public submit: boolean = false;

    /**
     * send state
     *
     * @type {boolean}
     */
    public send: boolean = false;

    /**
     * initial loading state
     *
     * @type {boolean}
     */
    public loading: boolean = true;

    /**
     * Unsubscribe reason
     *
     * @type {string}
     */
    public reason: string = '';

    /**
     * Unsubscribe reason
     *
     * @type {number}
     */
    public reasonTypes = [
        false,
        false,
        false,
        false,
        false,
    ];

    constructor(
        public route: ActivatedRoute,
        public settingsService: ParticipantSettingService,
    ) {

        super();
    }

    ngOnInit() {

        let participantId = this.route.snapshot.queryParams['id'];
        let token = this.route.snapshot.queryParams['t'];

        this.settingsService.getMailSetting(participantId, token).subscribe(
            (success) => {

                this.event = new Event(success.event);

                this.loading = false;
            },
            (error) => {
                this.showError(error.error.message);

                this.loading = false;
            });
    }

    /**
     * save
     *
     * @return void
     */
    public save() {
        this.submit = true;

        let participantId = this.route.snapshot.queryParams['id'];
        let token = this.route.snapshot.queryParams['t'];

        // src for tracking
        let src = this.route.snapshot.queryParams['s'] || this.route.snapshot.queryParams['src'];
        let srcId = this.route.snapshot.queryParams['sId'] || this.route.snapshot.queryParams['srcId'] || null;

        let reasons = [];

        this.reasonTypes.forEach((checked, index) => {
            if (checked) {
                reasons.push(this.translate.instant('UNSUBSCRIBE_REASON_' + (index + 1)));
            }
        });

        if (this.reason) {
            reasons.push(this.reason);
        }

        // load participant data by mail setting token
        this.settingsService.unsubscribe(participantId, token, src, srcId, reasons.join(' | ')).subscribe(
            (success) => {
                this.loading = false;
                this.submit = false;
                this.send = true;
                // this.showSuccess(success.message);
            },
            (error) => {
                this.showError(error.error.message);

                this.submit = false;
            });

    }

    contactSupport() {
        let url = 'mailto:' + this.translate.instant('SUPPORT_EMAIL');
        window.open(url, '_system', 'noreferrer');
    }

    showFeatures() {

        let url = environment.benefitUrl['en'];

        if (environment.benefitUrl[this.translate.currentLang]) {
            url = environment.benefitUrl[this.translate.currentLang];
        }

        window.open(url, '_system', 'noreferrer');
    }

    ngOnDestroy() {
    }

}
